import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {
  SecuritySettingsApiService
} from '../../../services/api/settings/administration/security/security-settings-api.service';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import _ from 'lodash';
import {FormControl, FormGroup} from '@angular/forms';
import {confirmPasswordValidator} from '../../../utils/confirm-password-validator.directive';
import {CustomErrorStateMatcher} from '../../../utils/custom-error-state-matcher.directive';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'security-settings',
  templateUrl: './security-settings.component.html',
  styleUrls: ['./security-settings.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SecuritySettingsComponent implements OnInit {

  security: any = {configuratorHostname: '', isConfCommunicationIpBased: true};
  securityBeforeChanges = {configuratorIpAddress: '', configuratorHostname: '', isConfCommunicationIpBased: true};
  configuratorPossibleIps: string[];
  communicationMethodOptions = [{text: 'IP Based', value: true}, {text: 'Hostname Based', value: false}];
  confirmationControl: FormGroup;
  confirmationRouterControl: FormGroup;
  matcher: any;
  canSubmit: boolean;

  constructor( private userPrivilege: UserPrivilegeService,
               private securitySettingsApiService: SecuritySettingsApiService,
               private loaderService: LoaderService,
               private dialog: MatDialog) {
    this.canSubmit = this.userPrivilege.isAuthorized();
  }

  ngOnInit(): void {
    this.matcher = new CustomErrorStateMatcher();
    this.confirmationControl = new FormGroup({
      password: new FormControl(),
      'confirm-password': new FormControl(),
    }, { validators: confirmPasswordValidator });

    this.confirmationRouterControl = new FormGroup({
      password: new FormControl(),
      'confirm-password': new FormControl(),
    }, { validators: confirmPasswordValidator });

    this.loaderService.showMainContainer();
    this.initialSecurityData();
  }

  initialSecurityData(): void {
    this.securitySettingsApiService.getSecurityConfiguration().subscribe((securitySettingsData) => {
      this.securityBeforeChanges = securitySettingsData;
      this.security = {...securitySettingsData};
      this.security.httpHttpsEnabled = !securitySettingsData.httpHttpsEnabled;
      this.configuratorPossibleIps = securitySettingsData.configuratorPossibleIps.map((ip) => ({text: ip, value: ip}));

      this.loaderService.hideMainContainer();
    });
  }

  onSubmit(): any {

    if (!this.isARMConfigurationChanged()){
      this.callToUpdateSecurityConfiguration();
    }else{
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '460px',
        data: {
          message: 'Due to the ARM configuration changes, each of the nodes in the network will be updated'
        }
      });

      dialogRef.componentInstance.onApply.subscribe(() => {
        this.callToUpdateSecurityConfiguration();
        dialogRef.close();
      });
    }

  }

  isARMConfigurationChanged(): boolean {
    return !_.isEqual(this.securityBeforeChanges.configuratorIpAddress, this.security.configuratorIpAddress) ||
      !_.isEqual(this.securityBeforeChanges.configuratorHostname, this.security.configuratorHostname) ||
      !_.isEqual(this.securityBeforeChanges.isConfCommunicationIpBased, this.security.isConfCommunicationIpBased);
  }

  private generateSecurityConfigurationObject(): any {
    const securityConfiguration = { ...this.security };
    securityConfiguration.httpHttpsEnabled = !this.security.httpHttpsEnabled;
    if (securityConfiguration.routerSshPasswordConfirm) {
      delete securityConfiguration.routerSshPasswordConfirm;
    }

    if (securityConfiguration.confSshPasswordConfirm) {
      delete securityConfiguration.confSshPasswordConfirm;
    }

    return securityConfiguration;
  }

  callToUpdateSecurityConfiguration(): any {
    const securityConfiguration = this.generateSecurityConfigurationObject();

    this.securitySettingsApiService.updateSecurityConfiguration(securityConfiguration).subscribe(() => {
      this.initialSecurityData();
    });
  }

}
